import { PRODUCT_TYPE } from '@lyrahealth-inc/shared-app-logic'

import colors from '../../styles/_0colors.scss'

export interface ProductTypeColors {
  primaryAction: string
  primaryDark: string
}

/**
 * Get colors based on product type
 * This function provides a scalable way to handle colors for different product types
 */
export const getProductTypeColors = (productType?: PRODUCT_TYPE): ProductTypeColors => {
  switch (productType) {
    case PRODUCT_TYPE.SELECT:
      return {
        primaryAction: colors.primary_action_lyra_select,
        primaryDark: colors.primary_dark_lyra_select,
      }
    case PRODUCT_TYPE.WFMH:
    default:
      return {
        primaryAction: colors.x_primary_action,
        primaryDark: colors.x_primary_dark,
      }
  }
}

/**
 * Check if a product type uses custom colors (not WFMH default)
 */
export const hasCustomColors = (productType?: string): boolean => {
  return productType !== undefined && productType !== PRODUCT_TYPE.WFMH
}
